var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ path: _vm.redirectToHome }}},[_c('img',{staticClass:"mayday-logo",attrs:{"src":"/img/brand/mayday-logo-rounded.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }